// extracted by mini-css-extract-plugin
module.exports = {"label":"style-module_label__Q-RV_BbHjfIYcOOaMuAjL","numberPicker":"style-module_numberPicker__9xsv3mhbHmR8EmERAUidq","digit":"style-module_digit__3kv_EFQVSDmN3eGTKkc22v"};